export const LOCALE_STORAGE_KEY = 'thetavern.locale';

export const locales = [
  { code: 'en', label: 'English', shortLabel: 'EN', dir: 'ltr' },
  { code: 'fr', label: 'Fran\u00e7ais', shortLabel: 'FR', dir: 'ltr' },
];

export const supportedLocaleCodes = locales.map((locale) => locale.code);

export const fallbackLocale = 'en';

export const normalizeLanguage = (language) => {
  const normalized = String(language || '').split('-')[0].toLowerCase();

  return supportedLocaleCodes.includes(normalized) ? normalized : fallbackLocale;
};

export const getLocale = (language) =>
  locales.find((locale) => locale.code === normalizeLanguage(language)) ||
  locales[0];

export const applyLanguageSideEffects = (language) => {
  const locale = getLocale(language);

  document.documentElement.lang = locale.code;
  document.documentElement.dir = locale.dir;

  return locale;
};
